ForecastListController.$inject = ['$scope', '$q', 'forecastService']

function ForecastListController($scope, $q, forecastService) {
  let promises = []
  $scope.filter = { INDIA: true, BRAZIL: true, CHINA: true }
  $scope.forecast = { items: [] }
  $scope.forecast_dc = []
  $scope.dcs = []

  promises.push(forecastService.getView())

  Promise.all(promises).then(results => {
    $scope.forecast.items = results[0]
    console.log($scope.forecast.items.length)
  })

  forecastService.getDCs().then(result => {
    $scope.dcs = _.orderBy(result, 'nome')
  })

  function getForecastByDC() {
    return forecastService.getForecastByDC().then(result => {
      const forecast_dc = result
        // Monta forecast no formato para montar a tabela
        .map(item => {
          let items = result.filter(i => i.id_material_cliente === item.id_material_cliente)

          // Ordena por nome para garantir que o item seja
          // exibido na coluna correta.
          items = _.orderBy(items, 'nome_dc')

          return {
            nome: item.nome,
            id: item.id_programacao_item,
            id_programacao_item: item.id_programacao_item,
            possui_ordem: item.possui_ordem,
            possui_ordem_revisao: item.possui_ordem_revisao,
            id_material_cliente: item.id_material_cliente,
            country: item.country,
            flagSrc: item.flagSrc,
            items, // Armazena pedidos de cada DC
          }
        })
        // Filtra itens sem pedidos ou nada aprovado
        .filter(item => item.items.some(i => i.Pedido > 0 || i.Atendido > 0))

      $scope.forecast_dc = _.uniqBy(forecast_dc, 'id_material_cliente')
    })
  }

  function applyFilter(item) {
    let noFilter = filterObj => Object.keys(filterObj).every(key => !filterObj[key])
    let display = $scope.filter[_.toUpper(item.country)] || noFilter($scope.filter)
    return display
  }

  function findBg(item) {
    const perc = item.Percentual
    const pedido = item.Pedido

    if (pedido !== 0) {
      if (_.inRange(perc, 70, 99999)) return 'bg-green disabled'
      if (_.inRange(perc, 0, 40)) return 'bg-red disabled'
      if (_.inRange(perc, 40, 70)) return 'bg-yellow disabled'
    }
  }

  function viewItem(item) {
    // Busca item correspondente em $scope.forecast
    const matching = $scope.forecast.items.find(i => i.material_id === item.id_material_cliente)

    return forecastService.viewItem(matching)
  }

  getForecastByDC()

  $scope.findBg = findBg
  $scope.getView = forecastService.getView
  $scope.viewItem = viewItem
  $scope.applyFilter = applyFilter
}

ForecastViewController.$inject = ['$scope', 'forecastService', '$routeParams']

function ForecastViewController($scope, forecastService, $routeParams) {
  let item_id = $routeParams.id
  let promises = []
  $scope.item = {}
  $scope.item.bundles = []
  $scope.item.suppliers = []
  $scope.item.data = {}

  $scope.chart = {}
  $scope.supplierChart = {}
  $scope.filter = { ANAHEIM: true, HOUSTON: true, SEATTLE: true }

  let bundlesCache = []

  promises.push(forecastService.getItem(item_id))

  Promise.all(promises)
    .then(results => {
      let item = results[0]
      $scope.item = item
      $scope.totalOrders = item.pedido_lb + item.pedido_h + item.pedido_s
      return item
    })
    .then(item => {
      $scope.chart = forecastService.createDoughnutChart(item)
      return item
    })
    .then(forecastService.getItemData)
    .then(data => {
      $scope.item.bundles = data.bundles
      bundlesCache = data.bundles
      // $scope.supplierChart = forecastService.createSupplierChart(data);

      // TODO remove
      //  $scope.filterNovemberPOs(true)

      return data
    })

  function applyFilter(item) {
    let noFilter = filterObj => Object.keys(filterObj).every(key => !filterObj[key])
    let display = $scope.filter[_.toUpper(item.dc)] || noFilter($scope.filter)
    return display
  }

  $scope.applyFilter = applyFilter
  $scope.openImage = forecastService.openImage
}

app.controller('ForecastListController', ForecastListController)
app.controller('ForecastViewController', ForecastViewController)
